export default "__VITE_ASSET__BMtcHN7E__"